export interface ISeoProps {
	title: string;
	description: string;
}

export type seoPageTypes =
	| 'withdrawals'
	| 'business-withdrawals'
	| 'transactions'
	| 'security'
	| 'settings'
	| 'home'
	| 'assets'
	| 'analytics'
	| 'kyb'
	| 'reset-password'
	| 'login'
	| 'register'
	| 'addresses'
	| 'wallet'
	| 'team'
	| 'developer'
	// settings
	| 'auto-settlement'
	| 'crypto-settings'
	| 'profile'
	| 'activity-log'
	| 'change-password'
	| 'create-pin'
	| 'reset-pin'
	| 'update-pin'
	| 'two-fa';

export const seoData: Record<seoPageTypes, ISeoProps> = {
	'withdrawals': {
		title: 'Withdrawals - Breet Business',
		description: 'Manage withdrawals efficiently and securely with Breet Business.',
	},
	'business-withdrawals': {
		title: 'Business Withdrawals - Breet Business',
		description: 'Manage business withdrawals efficiently and securely with Breet Business.',
	},
	'transactions': {
		title: 'Transactions - Breet Business',
		description: 'Track, review, and manage all your business transactions securely in Breet Business.',
	},
	'security': {
		title: 'Settings | Security - Breet Business',
		description: 'Secure your account with 2FA and more.',
	},
	'settings': {
		title: 'Settings - Breet Business',
		description: 'Update account preferences, security settings, and compliance details in Breet Business.',
	},
	'home': {
		title: 'Dashboard - Breet Business',
		description: 'Get a complete overview of your business operations and verification status on the Breet Business dashboard.',
	},
	'assets': {
		title: 'Assets - Breet Business',
		description: 'Manage and monitor your verified business assets with Breet Business.',
	},
	'analytics': {
		title: 'Analytics - Breet Business',
		description: 'Access detailed analytics and insights to track your business performance in Breet Business.',
	},
	'kyb': {
		title: 'KYB & Compliance - Breet Business',
		description:
			'Our KYB process is built for speed, trust, and compliance; so your business can get verified and scale confidently without friction.',
	},
	'reset-password': {
		title: 'Reset Password - Breet Business',
		description: 'Reset your Breet Business password to regain secure access to your account.',
	},
	'login': {
		title: 'Login - Breet Business',
		description: 'Securely log in to your Breet Business account to manage verification, transactions, and business operations.',
	},
	'register': {
		title: 'Register a New Business - Breet Business',
		description: 'Create your Breet Business account to start managing crypto payments, settlements, and payouts.',
	},
	'addresses': {
		title: 'Wallet Addresses - Breet Business',
		description: 'Manage and monitor your verified business assets with Breet Business.',
	},
	'wallet': {
		title: 'Wallet - Breet Business',
		description: 'View your business wallet balances and withdrawal history with Breet Business.',
	},
	'team': {
		title: 'Settings | Team Management - Breet Business',
		description: 'Invite teammates and manage roles and access for your business on Breet Business.',
	},
	'developer': {
		title: 'Developer - Breet Business',
		description: 'Manage and monitor your verified business assets with Breet Business.',
	},
	'auto-settlement': {
		title: 'Settings | Auto Settlement - Breet Business',
		description: 'Configure automated settlements for fast and seamless payout workflows with Breet Business.',
	},
	'crypto-settings': {
		title: 'Settings | Crypto Settings - Breet Business',
		description: 'Customize supported cryptocurrencies and default transaction preferences for your business.',
	},
	'profile': {
		title: 'Settings | Business Profile - Breet Business',
		description: 'View and update your business profile details, contact information, and account identity.',
	},
	'activity-log': {
		title: 'Settings | Activity Log - Breet Business',
		description: 'Monitor account activity, audit trails, and security logs in Breet Business.',
	},
	'change-password': {
		title: 'Settings | Change Password - Breet Business',
		description: 'Update your password to keep your Breet Business account safe and secure.',
	},
	'create-pin': {
		title: 'Settings | Create Security PIN - Breet Business',
		description: 'Set up a new transaction PIN to add an extra layer of authorization to your actions.',
	},
	'reset-pin': {
		title: 'Settings | Reset Security PIN - Breet Business',
		description: 'Safely reset your transaction PIN to manage critical business operations securely.',
	},
	'update-pin': {
		title: 'Settings | Update Security PIN - Breet Business',
		description: 'Change your existing transaction PIN to maintain tight security over account actions.',
	},
	'two-fa': {
		title: 'Settings | Two-Factor Authentication - Breet Business',
		description: 'Manage your 2FA security settings to protect your Breet Business account from unauthorized access.',
	},
};
